import React from "react";

// Reusable hand-drawn style artistic SVG accents.
export function Squiggle({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 120 24" className={className} fill="none">
      <path
        d="M2 12 C 12 2, 22 22, 32 12 S 52 2, 62 12 S 82 22, 92 12 S 112 2, 118 12"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Star({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} fill={color}>
      <path d="M20 2 C21 14 26 19 38 20 C26 21 21 26 20 38 C19 26 14 21 2 20 C14 19 19 14 20 2 Z" />
    </svg>
  );
}

export function CircleOutline({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 60 60" className={className} fill="none">
      <circle cx="30" cy="30" r="26" stroke={color} strokeWidth="4" strokeDasharray="6 9" strokeLinecap="round" />
    </svg>
  );
}

export function Wave({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 100 20" className={className} fill="none">
      <path d="M2 10 q 8 -8 16 0 t 16 0 t 16 0 t 16 0 t 16 0" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
}
